<template>
  <div>
    <div class="layout-center-wrap">
      <!-- 접수 모드 : edit(false) / 조회,수정모드 : edit(true) -->
      <!-- 패치 가능, 불가능  -->
      <!-- 조회 , 수정 모드 : 수정 버튼, 조회 버튼 영역  -->
      <!--패치 내용 작성-->

      <h3 v-if="edit" class="section-title">보안 취약점 패치 접수 안내</h3>
      <div v-if="edit" class="notice-box">
        <p class="notice-box__text">
          한국인터넷진흥원 「정보통신망 이용 촉진 및 정보보호 등에 관한 법률」
          제47조의4 제4항에 따라 소프트웨어 사업자의 취약점 패치 프로그램을
          접수받고 있습니다. <br />아래 양삭에 맞추어 패치 프로그램을
          접수해주시기 바랍니다.
        </p>
        <p class="notice-box__text">
          ※ 「정보통신망 이용 촉진 및 정보보호 등에 관한 법률」 제47조의4
          제4항<br />
          「소프트웨어 진흥법」 제2조에 따른 소르프웨어 사업자는 보안에 관한
          취약점을 보완하는 프로그램을 제작하였을 때에는 한국인터넷진흥원에
          알려야 하고, <br />
          그 소프트웨어 사용자에게는 제작한 날부터 1개월 이내에 2회 이상 알려야
          한다.
        </p>
        <p class="notice-box__text">
          대검찰청, 경찰청, 인터넷진흥원, 금융기관 등을 사칭하는
          <span class="u-color-red"
            >피싱사이트, 피싱 문자로 인한 금전적 피해가 발생하고 있습니다.</span
          ><br />
          <span class="u-color-red"
            >사이트 접속 시 바로 개인정보를 입력하지 말고 먼저 사이트 주소를
            확인하시기 바랍니다.</span
          >
        </p>
      </div>
      <table class="board-write type-block--mobile">
        <tbody>
          <tr>
            <th scope="row">
              제조사명<span class="svg_icon icon_must" aria-hidden="true"></span
              ><span class="sr-only">필수입력</span>
            </th>
            <td>
              <label for="makrName" class="sr-only">제조사명 입력</label>
              <span>{{ userInfo.makrName || "-" }} </span>
            </td>
          </tr>
          <tr class="row--mobile-flex">
            <th scope="row">
              조치 구분<span
                class="svg_icon icon_must"
                aria-hidden="true"
              ></span
              ><span class="sr-only">필수입력</span>
            </th>
            <td>
              <!-- 접수 및 수정 모드 -->
              <div class="btn__wrap" v-if="edit && !detailMod">
                <label class="chk_btn"
                  ><input
                    type="radio"
                    name="radio1"
                    value="P"
                    v-model="replyInfo.submitType"
                    @click="initSelectedPatches()"
                  />
                  <p class="chk_btn__display">조치 계획서 접수</p>
                </label>
                <label class="chk_btn"
                  ><input
                    type="radio"
                    name="radio1"
                    value="R"
                    v-model="replyInfo.submitType"
                    @click="initSelectedPatches()"
                  />
                  <p class="chk_btn__display">조치 결과 접수</p>
                </label>
              </div>
              <!-- 상세조회 모드 -->
              <span v-else>{{
                replyInfo.submitType === "P"
                  ? "조치 계획서 접수"
                  : "조치 결과 접수"
              }}</span>
            </td>
          </tr>
          <tr>
            <th scope="row">
              KVE<span class="svg_icon icon_must" aria-hidden="true"></span
              ><span class="sr-only">필수입력</span>
            </th>
            <!-- 접수모드 -->
            <td>
              <label for="kve" class="sr-only"
                >KVE 입력 : 클릭 시 KVE 선택 창이 출력됩니다.</label
              >
              <input
                v-if="edit && !detailMod"
                type="text"
                placeholder="클릭 시 KVE 선택 창이 출력됩니다."
                id="kve"
                @click="openModal"
                v-model="selectedPatches"
                readonly
              />

              <span v-else>{{
                submitInfo.submitRequestInfos.map((p) => p.kve).join(", ")
              }}</span>
            </td>
          </tr>
          <tr
            v-if="
              edit && submitInfo.submitRequestInfos.length > 0 && !detailMod
            "
          >
            <th scope="row">분석 보고서 다운로드</th>
            <td>
              <button
                class="btn btn--green"
                style="margin: 5px 5px 0 0"
                v-for="item in submitInfo.submitRequestInfos"
                v-bind:key="item.kve"
                v-on:click="openVerifyModal(item.kve)"
              >
                {{ item.kve }}
              </button>
            </td>
          </tr>
          <tr
            v-if="
              edit &&
              replyInfo.submitType === 'R' &&
              submitInfo.submitRequestInfos.length > 0 &&
              !detailMod
            "
          >
            <th scope="row">조치 계획서 불러오기</th>
            <!-- 접수모드 -->
            <td>
              <button
                class="btn btn--dark_gray"
                style="margin: 5px 5px 0 0"
                v-for="item in submitInfo.submitRequestInfos"
                v-bind:key="item.kve"
                v-on:click="loadPatchPlan(item.kve)"
              >
                {{ item.kve }}
              </button>
            </td>
          </tr>
          <tr class="row--mobile-flex">
            <th scope="row">
              조치 가능 여부<span
                class="svg_icon icon_must"
                aria-hidden="true"
              ></span
              ><span class="sr-only">필수입력</span>
            </th>
            <td>
              <div v-if="edit" class="btn__wrap">
                <label class="chk_btn"
                  ><input
                    type="radio"
                    name="radio2"
                    :value="true"
                    v-model="replyInfo.hasActionOk"
                  />
                  <p class="chk_btn__display">가능</p>
                </label>
                <label class="chk_btn"
                  ><input
                    type="radio"
                    name="radio2"
                    :value="false"
                    v-model="replyInfo.hasActionOk"
                  />
                  <p class="chk_btn__display">불가능</p>
                </label>
              </div>
              <!-- 상세조회 모드 -->
              <span v-else>{{
                replyInfo?.hasActionOk ? "가능" : "불가능"
              }}</span>
            </td>
          </tr>
          <template v-if="replyInfo?.hasActionOk">
            <tr>
              <th v-if="replyInfo.submitType === 'R'" scope="row">
                패치 개발 일자<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span>
              </th>
              <th v-if="replyInfo.submitType === 'P'" scope="row">
                패치 개발 계획 일자<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span>
              </th>
              <td>
                <!-- 신규 작성 -->
                <div v-if="edit">
                  <label for="devCompDate" class="sr-only"
                    >패치 계획 일자 입력</label
                  ><input
                    type="date"
                    id="devCompDate"
                    v-model="replyInfo.devCompDate"
                  />
                </div>
                <span v-else> {{ replyInfo.devCompDate || "-" }} </span>
              </td>
            </tr>
            <tr>
              <th v-if="replyInfo.submitType === 'R'" scope="row">
                패치 배포 일자<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span>
              </th>
              <th v-if="replyInfo.submitType === 'P'" scope="row">
                패치 배포 계획 일자<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span>
              </th>
              <td>
                <div v-if="edit">
                  <label for="deployDate" class="sr-only"
                    >패치 배포 일자 입력</label
                  ><input
                    type="date"
                    id="deployDate"
                    v-model="replyInfo.deployDate"
                  />
                </div>
                <span v-else> {{ replyInfo.deployDate || "-" }} </span>
              </td>
            </tr>
            <tr v-if="replyInfo?.patchGuides.length > 0 && detailMod">
              <th scope="row">패치 안내 방법</th>
              <td class="path_methoud_field">
                <div class="notice_text_area">
                  <!-- 접수모드 -->
                  <div
                    class="btn__wrap type-min--130 type-mobile--col3"
                    style="display: flex"
                    v-if="edit"
                  >
                    <label
                      class="chk_btn"
                      v-for="guide in patchGuidesCodes"
                      :key="guide.cd"
                    >
                      <input
                        type="checkbox"
                        :value="guide.cd"
                        v-model="replyInfo.patchGuides"
                      />
                      <p class="chk_btn__display">{{ guide.cdNm || "-" }}</p>
                    </label>
                  </div>
                  <!-- 상세조회 모드 -->
                  <span v-else> {{ readPatchGuide() }}</span>
                </div>
              </td>
            </tr>
          </template>
          <tr>
            <th scope="row">
              {{
                replyInfo?.hasActionOk
                  ? replyInfo.submitType === "R"
                    ? "조치 결과 내용"
                    : "조치 계획 내용"
                  : "조치 불가 사유"
              }}<span class="svg_icon icon_must" aria-hidden="true"></span
              ><span class="sr-only">필수입력</span>
            </th>

            <td class="editor-field">
              <label for="replyCn" class="sr-only"
                >조치 계획 또는 결과 내용을 입력해주세요.</label
              >
              <template v-if="edit">
                <span v-if="replyInfo.submitType === 'P'">
                  ※ 취약한 제품에 대한 조치 계획을 형식 제한 없이 작성해 주시기
                  바랍니다.</span
                >
                <span v-else>
                  ※ 취약한 제품에 대한 조치 결과를 형식 제한 없이 작성해 주시기
                  바랍니다.
                  <br />
                  ※ 스크린샷, 소스코드, 보고서 등 증빙에 필요한 자료는 첨부해
                  주시기 바랍니다.</span
                ><br /><br />
              </template>
              <StacksEditor
                v-if="edit"
                v-model="replyInfo.replyCn"
                id="replyCn"
                :key="`replyCn-${replyCnEditorKey}`"
                @htmlchanged="onHtmlChanged"
              />
              <span
                v-else
                id="replyCn"
                v-dompurify-html="replyInfo.replyCnHtml || '-'"
              ></span>
            </td>
          </tr>
          <!-- 조치 증빙 첨부자료 -->
          <tr v-if="!(replyInfo.submitType === 'P' && replyInfo.hasActionOk)">
            <th scope="row">
              {{
                replyInfo?.hasActionOk
                  ? "조치 증빙 첨부자료"
                  : "조치 불가 증빙 첨부자료"
              }}
            </th>

            <td v-if="edit">
              <!-- 신규 작성 모드 -->
              <FileUpload
                :max-size="1000"
                :allow-ext="allowExt"
                @add="(file) => handleFileAdd(file, 'default')"
                :uploadFile="uploadFile"
              ></FileUpload>
            </td>
            <td v-else>
              <!-- <div class="readonly-value"> -->
              <template v-if="replyInfo?.uploadFiles?.length > 0">
                <a
                  class="link-primary"
                  @click.prevent="downloadFile(replyInfo.uploadFiles[0])"
                >
                  {{ replyInfo?.uploadFiles[0]?.name || "-" }}
                </a>
              </template>
              <template v-else> 첨부자료 없음</template>
              <!-- </div> -->
            </td>
          </tr>
          <template v-if="replyInfo?.hasActionOk">
            <tr v-if="replyInfo.submitType === 'R'">
              <th scope="row">
                조치 안내 내용<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span>
              </th>

              <td class="editor-field">
                <label for="actionGuide" class="sr-only"
                  >조치 안내 내용을 입력해주세요.</label
                >
                <template v-if="edit">
                  <span
                    >※ 취약한 제품에 대한 사용자 등에게 조치 안내한 내용을 형식
                    제한 없이 작성헤 주시기 바랍니다.<br />
                    ※ 스크린샷, 소스코드, 보고서 등 증빙에 필요한 자료는 첨부해
                    주시기 바랍니다.</span
                  ><br /><br
                /></template>
                <StacksEditor
                  v-if="edit"
                  v-model="replyInfo.actionGuide"
                  id="actionGuide"
                  :key="`actionGuide-${guideEditorKey}`"
                  @htmlchanged="onHtmlChanged"
                />
                <span
                  v-else
                  id="actionGuide"
                  v-dompurify-html="replyInfo.actionGuideHtml || '-'"
                ></span>
              </td>
            </tr>
            <!-- 조치 안내 증빙 첨부자료 -->
            <tr v-if="replyInfo.submitType === 'R'">
              <th scope="row">조치 안내 증빙 첨부자료</th>
              <td v-if="edit">
                <!-- 신규 작성 모드 -->
                <FileUpload
                  :max-size="100"
                  :allow-ext="allowExt"
                  @add="(file) => handleFileAdd(file, 'guide')"
                  :uploadFile="actionGuideFiles"
                ></FileUpload>
              </td>
              <td v-else>
                <!-- <div class="readonly-value"> -->
                <template v-if="replyInfo?.actionGuideFiles?.length > 0">
                  <a
                    class="link-primary"
                    @click.prevent="downloadFile(replyInfo.actionGuideFiles[0])"
                  >
                    {{ replyInfo?.actionGuideFiles[0]?.name || "-" }}
                  </a>
                </template>
                <template v-else>조치 안내 증빙 첨부자료 없음</template>
                <!-- </div> -->
              </td>
            </tr>

            <tr>
              <th scope="row">
                납품 현황<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span>
              </th>
              <td class="delivery-field" v-if="edit">
                <div
                  class="btn__wrap delivery-field__inner"
                  v-if="deliveryStatusCodes.length > 0"
                >
                  <div
                    class="delivery-field__item"
                    v-for="status in deliveryStatusCodes"
                    :key="status.cd"
                  >
                    <label class="chk_btn" :class="{ disabled: edit }">
                      <input
                        type="checkbox"
                        v-model="status.checked"
                        @change="onDeliveryStatusChange(status)"
                        @click="
                          isDeliveryStatusDisabled(status)
                            ? $event.preventDefault()
                            : null
                        "
                      />
                      <p class="chk_btn__display">{{ status.cdNm }}</p>
                      <div
                        class="delivery-field__number"
                        :style="{
                          visibility:
                            status.cd === 'NOT' ? 'hidden' : 'visible',
                        }"
                      >
                        <input
                          type="number"
                          placeholder="0"
                          :aria-label="`${status.cdNm} 수량`"
                          v-model.number="status.count"
                          :disabled="!status.checked"
                        />
                        개
                      </div>
                    </label>
                  </div>
                </div>
              </td>
              <td v-else>
                <!-- 상세 조회 모드  -->
                <span> {{ readDeliveryStatus() }} </span>
              </td>
            </tr>
            <tr>
              <th scope="row">제품 시장 점유율</th>
              <td>
                <!-- 접수 모드 -->
                <div class="layout-flex-row" v-if="edit">
                  <label for="marketShare" class="sr-only"
                    >제품 시장 점유율 %</label
                  >
                  <input
                    type="number"
                    class="board-write__input--narrow"
                    id="marketShare"
                    v-model="replyInfo.marketShare"
                  />
                  % /
                  <label for="marketRanking" class="sr-only"
                    >제품 시장 점유율 위</label
                  >
                  <input
                    type="number"
                    class="board-write__input--narrow"
                    id="marketRanking"
                    v-model="replyInfo.marketRanking"
                  />
                  위
                </div>
                <!-- 조회  -->
                <span v-else
                  >{{
                    replyInfo.marketShare ? `${replyInfo.marketShare}%` : ""
                  }}
                  {{
                    replyInfo.marketRanking
                      ? `${replyInfo.marketRanking}위`
                      : ""
                  }}
                  {{
                    !replyInfo.marketShare && !replyInfo.marketRanking
                      ? "-"
                      : ""
                  }}</span
                >
              </td>
            </tr>
            <tr class="row--mobile-flex">
              <th scope="row">
                오픈소스 여부<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span>
              </th>
              <td>
                <div class="btn__wrap" v-if="edit">
                  <label class="chk_btn"
                    ><input
                      type="radio"
                      name="radio3"
                      :value="true"
                      v-model="replyInfo.hasOpenSrc"
                    />
                    <p class="chk_btn__display">네</p>
                  </label>
                  <label class="chk_btn"
                    ><input
                      type="radio"
                      name="radio3"
                      :value="false"
                      v-model="replyInfo.hasOpenSrc"
                    />
                    <p class="chk_btn__display">아니오</p>
                  </label>
                </div>
                <!-- 조회 모드 -->
                <span v-else>
                  {{ replyInfo.hasOpenSrc ? "네" : "아니오" }}
                </span>
              </td>
            </tr>
            <tr v-if="replyInfo.hasOpenSrc" class="tr--blue">
              <th style="display: flex" scope="row">
                소스 저장소(OSS)<span class="svg_icon">
                  <Tooltip :item="`오픈소스 코드가 호스트 된 저장소 URL`">
                    <i class="svg_icon icon_tip" aria-hidden="true"></i>
                  </Tooltip>
                </span>
              </th>
              <td>
                <label for="input7" class="sr-only"
                  >소스 저장소(OSS) 입력 : 예) https://git.kernel.org</label
                >
                <input
                  v-if="edit"
                  type="text"
                  id="input7"
                  placeholder="예) https://git.kernel.org"
                  v-model="replyInfo.openSrcStore"
                />
                <span v-else> {{ replyInfo.openSrcStore || "-" }} </span>
              </td>
            </tr>
            <tr v-if="replyInfo.hasOpenSrc" class="tr--blue">
              <th style="display: flex" scope="row">
                소스코드 파일(OSS)<span class="svg_icon">
                  <Tooltip item="취약점이 발생한 코드 파일이나 디렉터리 경로">
                    <i class="svg_icon icon_tip" aria-hidden="true"></i>
                  </Tooltip>
                </span>
              </th>
              <td>
                <label for="input8" class="sr-only"
                  >소스코드 파일(OSS) 입력 : 예) hello.c</label
                >
                <input
                  v-if="edit"
                  type="text"
                  id="input8"
                  placeholder="예) hello.c"
                  v-model="replyInfo.openSrcFile"
                />
                <span v-else> {{ replyInfo.openSrcFile || "-" }} </span>
              </td>
            </tr>

            <tr>
              <th style="display: flex" scope="row">
                제품 이름<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span
                ><span class="svg_icon">
                  <Tooltip item="영향받는 제품 이름">
                    <i class="svg_icon icon_tip" aria-hidden="true"></i>
                  </Tooltip>
                </span>
              </th>
              <td>
                <label for="input10" class="sr-only"
                  >제품 이름 입력 : 예) 사이버 보안 취약점 정보 포털 홈페이지,
                  보호나라
                </label>
                <input
                  v-if="edit"
                  type="text"
                  id="input10"
                  placeholder="예) 사이버 보안 취약점 정보 포털 홈페이지, 보호나라 "
                  v-model="replyInfo.swNm"
                />
                <span v-else> {{ replyInfo.swNm || "-" }} </span>
              </td>
            </tr>
            <tr>
              <th style="display: flex" scope="row">
                설치 환경<span class="svg_icon">
                  <Tooltip :item="`제품이 동작하는 운영체제나 CPU아키텍쳐`">
                    <i class="svg_icon icon_tip" aria-hidden="true"></i>
                  </Tooltip>
                </span>
              </th>
              <td>
                <label for="input11" class="sr-only"
                  >설치 환경 입력 : 예) x86, Android, Windows, MacOS 등</label
                >
                <input
                  v-if="edit"
                  type="text"
                  id="input11"
                  placeholder="예) x86, Android, Windows, MacOS 등"
                  v-model="replyInfo.platform"
                />
                <span v-else> {{ replyInfo.platform || "-" }} </span>
              </td>
            </tr>
            <tr class="row--mobile-flex">
              <th scope="row">
                홈페이지 여부<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span
                ><span class="svg_icon">
                  <Tooltip :item="`해당 제품이 서비스(홈페이지)인지 여부`">
                    <i class="svg_icon icon_tip" aria-hidden="true"></i>
                  </Tooltip>
                </span>
              </th>
              <td>
                <div class="btn__wrap" v-if="edit">
                  <label class="chk_btn"
                    ><input
                      type="radio"
                      name="radio4"
                      :value="true"
                      v-model="replyInfo.hasHomePage"
                    />
                    <p class="chk_btn__display">네</p>
                  </label>
                  <label class="chk_btn"
                    ><input
                      type="radio"
                      name="radio4"
                      :value="false"
                      v-model="replyInfo.hasHomePage"
                    />
                    <p class="chk_btn__display">아니오</p>
                  </label>
                </div>
                <!-- 상세보기화면에서 홈페이지 여부 단순 표현  -->
                <span v-else>
                  {{ replyInfo.hasHomePage ? "네" : "아니오" }}
                </span>
              </td>
            </tr>
            <tr v-if="replyInfo.hasHomePage" class="tr--blue">
              <th scope="row">홈페이지 주소</th>
              <td>
                <label for="input7" class="sr-only"
                  >홈페이지 주소 입력 : 예) https://knvd.krcert.or.kr</label
                >
                <input
                  v-if="edit"
                  type="text"
                  id="input7"
                  placeholder="예) https://knvd.krcert.or.kr"
                  v-model="replyInfo.homePageUrl"
                />
                <span v-else> {{ replyInfo.homePageUrl || "-" }} </span>
              </td>
            </tr>

            <tr v-if="!replyInfo.hasHomePage" class="tr--blue">
              <th scope="row">
                취약한 버전 범위<span class="svg_icon">
                  <Tooltip :item="`취약점이 존재하는 소프트웨어 버전 범위`">
                    <i class="svg_icon icon_tip" aria-hidden="true"></i>
                  </Tooltip>
                </span>
              </th>
              <td>
                <div
                  v-show="edit"
                  style="margin-top: 5px"
                  class="range-field"
                  v-for="(version, index) in replyInfo.vulnVersionRange"
                  :key="index"
                >
                  <div class="range-field__item">
                    <label :for="`minVersion-${index}`" class="sr-only"
                      >취약한 버전 범위 입력 : 예) 1.0.0
                    </label>
                    <div>
                      <input
                        type="text"
                        :id="`minVersion-${index}`"
                        placeholder="예) 1.0.0  "
                        v-model="version.minVersion"
                        :readonly="replyInfo.hasNoVulnVer"
                      />
                    </div>
                    <label :for="`minVersionRange-${index}`" class="sr-only"
                      >취약한 버전 범위</label
                    >
                    <select
                      :id="`minVersionRange-${index}`"
                      :style="{ width: '100px' }"
                      v-model="version.minVersionRange"
                      :disabled="replyInfo.hasNoVulnVer"
                    >
                      <option value="INCLD">이상</option>
                      <option value="EXCLD">초과</option>
                    </select>
                  </div>
                  <div class="range-field__item">
                    <label :for="`maxVersion-${index}`" class="sr-only"
                      >취약한 버전 범위 입력 : 예) 1.0.0
                    </label>
                    <input
                      type="text"
                      :id="`maxVersion-${index}`"
                      placeholder="예) 1.0.0  "
                      v-model="version.maxVersion"
                      :readonly="replyInfo.hasNoVulnVer"
                    />
                    <label :for="`maxVersionRange-${index}`" class="sr-only"
                      >취약한 버전 범위</label
                    >
                    <select
                      :id="`maxVersionRange-${index}`"
                      :style="{ width: '100px' }"
                      v-model="version.maxVersionRange"
                      :disabled="replyInfo.hasNoVulnVer"
                    >
                      <option value="INCLD">이하</option>
                      <option value="EXCLD">미만</option>
                    </select>
                  </div>
                  <button
                    type="button"
                    class="btn btn--m btn--blue btn--mobile-full"
                    @click="addVulnVersionRange"
                  >
                    <i class="svg_icon icon_add white" aria-hidden="true"></i
                    >추가
                  </button>
                  <button
                    type="button"
                    class="btn btn--m btn--medium_gray btn--mobile-full"
                    @click="removeVulnVersionRange(index)"
                    v-if="replyInfo.vulnVersionRange.length > 1"
                  >
                    <i
                      class="svg_icon icon_trashcan gray"
                      aria-hidden="true"
                    ></i
                    >삭제
                  </button>
                  <button
                    type="button"
                    class="btn btn--m btn--skyblue btn--mobile-full"
                    v-else
                    @click="handleNoVulnVer()"
                  >
                    버전 없음
                  </button>
                </div>
                <input
                  type="text"
                  id="input21"
                  v-if="replyInfo.hasNoVulnVer && edit"
                  v-model="replyInfo.noVulnVerReason"
                  placeholder="취약한 버전이 존재하지 않는 이유를 입력하세요"
                  maxlength="100000"
                />
                <div class="char-count" v-if="replyInfo.hasNoVulnVer && edit">
                  <span>{{ reasonCount }}</span> /
                  <span class="maximum">100000(자)</span>
                </div>
                <span v-if="!edit" style="white-space: pre-line">
                  {{ readVulnVersionRange() }}</span
                >
              </td>
            </tr>
            <tr
              v-if="
                !replyInfo.hasHomePage &&
                !replyInfo.hasNoVulnVer &&
                replyInfo.vulnVersionRange.length > 0
              "
            >
              <td colspan="2" class="vuln-field" v-if="edit">
                <ul
                  class="vuln-field__form"
                  v-for="(version, index) in replyInfo.patchVersionMap"
                  :key="index"
                >
                  <li class="vuln-field__item">
                    <p class="vuln-field__tit">취약한 버전</p>
                    <div class="vuln-field__input">
                      <label :for="`vulnVersion-${index}`" class="sr-only"
                        >취약한 버전 입력</label
                      >
                      <input
                        type="text"
                        :id="`vulnVersion-${index}`"
                        placeholder="취약한 버전을 입력하세요"
                        v-model="version.vulnVersion"
                      />
                    </div>
                  </li>
                  <li class="vuln-field__item">
                    <p class="vuln-field__tit">해결된 버전</p>
                    <div class="vuln-field__input">
                      <label :for="`patchedVersion-${index}`" class="sr-only"
                        >해결된 버전 입력</label
                      >
                      <input
                        type="text"
                        :id="`patchedVersion-${index}`"
                        placeholder="해결된 버전을 입력하세요"
                        v-model="version.patchedVersion"
                      />
                    </div>
                  </li>
                  <li class="vuln-field__item row--mobile-flex">
                    <p class="vuln-field__tit">해시 등록 방법</p>
                    <div class="vuln-field__input">
                      <div class="btn__wrap">
                        <button
                          type="button"
                          class="btn btn--medium_blue btn--m"
                          @click="
                            hashInputMethod = 'file';
                            onHashFileClick(index);
                          "
                        >
                          파일추출
                        </button>
                        <button
                          type="button"
                          class="btn btn--medium_blue btn--m"
                          @click="hashInputMethod = 'direct'"
                        >
                          직접입력
                        </button>
                      </div>
                    </div>
                  </li>
                  <li
                    class="vuln-field__item"
                    v-if="version.fileHash || hashInputMethod"
                  >
                    <p class="vuln-field__tit">취약한 파일 해시</p>
                    <div class="vuln-field__input">
                      <label :for="`fileHash-${index}`" class="sr-only"
                        >SHA-256 해시를 파일 업로드 추출 및 직적입력하여 주시기
                        바랍니다.</label
                      >
                      <input
                        type="text"
                        :id="`fileHash-${index}`"
                        placeholder="SHA-256 해시를 파일 업로드 추출 및 직적입력하여 주시기 바랍니다."
                        v-model="version.fileHash"
                        :readonly="hashInputMethod === 'file'"
                      />
                    </div>
                  </li>
                  <input
                    type="file"
                    ref="hashFileInput"
                    @change="onHashFileChange($event, index)"
                    hidden
                  />

                  <li class="vuln-field__item btns">
                    <p class="vuln-field__tit"></p>
                    <div class="vuln-field__input">
                      <div class="vuln-field__btns">
                        <button
                          type="button"
                          class="btn btn--m btn--blue"
                          @click="addPatchVersionMap"
                        >
                          <i
                            class="svg_icon icon_add white"
                            aria-hidden="true"
                          ></i
                          >추가
                        </button>
                        <button
                          type="button"
                          class="btn btn--m btn--medium_gray"
                          @click="removePatchVersionMap(index)"
                          v-if="replyInfo.patchVersionMap.length > 1"
                        >
                          <i
                            class="svg_icon icon_trashcan gray"
                            aria-hidden="true"
                          ></i
                          >삭제
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </td>
              <td
                colspan="2"
                class="vuln-field"
                v-if="!edit"
                style="white-space: pre-line"
              >
                {{ readPatchVersionMap() }}
              </td>
            </tr>
            <tr>
              <th scope="row">비고</th>
              <td>
                <div v-if="edit">
                  <label for="input21" class="sr-only">비고 입력</label>
                  <input
                    type="text"
                    id="input21"
                    v-model="replyInfo.bigo"
                    maxlength="100000"
                  />
                  <div class="char-count">
                    <span>{{ bigoCount }}</span> /
                    <span class="maximum">100000 </span> (자)
                  </div>
                </div>
                <span v-else> {{ replyInfo.bigo || "-" }} </span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <section class="section-accordion__wrap type-bullet">
        <!-- 1. CVE ID 발급 및 공개관련 안내 -->
        <article class="section-accordion__item">
          <h3 class="section-accordion__header">
            <button
              type="button"
              class="section-accordion__btn"
              aria-controls="panel-1"
              id="accordion-trigger-1"
            >
              <span class="section-accordion__num" aria-hidden="true"></span>
              <span class="section-accordion__title"
                >CVE ID 발급 및 공개관련 안내</span
              >
            </button>
          </h3>
          <div
            id="panel-1"
            class="section-accordion__panel"
            role="region"
            aria-labelledby="accordion-trigger-1"
          >
            <div class="section-accordion__content">
              ○ 저희 한국인터넷진흥원은 신속한 패치를 장려하고, 해당 취약점으로
              인한 S/W 이용자 및 고객사의 피해 최소화를 위해 CVE ID 발급 조건에
              부합하는 취약점의 경우, 이용자에게 보안 패치를 안내한 날로부터
              90일(3개월) 후 제조사의 동의하에 CVE ID를 발급 및 공개하고
              있습니다.<br />
              ○ CVE ID 발급 및 공개를 동의하실 경우, 취약점의 평가 결과 및
              중요도에 따라 CVE ID가 발급 및 공개 될 수 있습니다.
              <br />
              ※ CVE(Common Vulnerability Exposure)란? 공개적으로 알려진
              소프트웨어의 보안 취약점을 가리키는 고유 표기<br />
              ※ CVE 확인 사이트 : 보안 취약점
              정보포털(https://knvd.krcert.or.kr/), KrCERT
              보호나라(https://www.boho.or.kr/), NVD(https://nvd.nist.gov/)<br />
              ※ CVE ID 발급 및 공개 시 취약점 상세 내용은 사용되지 않음<br />
              ※ CVE ID 발급 및 공개 시점 : 이용자에게 보안패치를 안내한 날로부터
              90일(3개월) 후
              <div class="section-accordion__agree">
                <p class="section-accordion__agree__desc">
                  CVE ID 발급 및 공개에 동의합니다.
                </p>
                <div class="chk__wrap">
                  <label class="chk chk--circle"
                    ><input
                      type="radio"
                      name="agree1"
                      :value="false"
                      v-model="replyInfo.hasCveIdAgree"
                    />동의안함</label
                  >
                  <label class="chk chk--circle"
                    ><input
                      type="radio"
                      name="agree1"
                      :value="true"
                      v-model="replyInfo.hasCveIdAgree"
                    />동의함</label
                  >
                </div>
              </div>
            </div>
          </div>
        </article>
        <!-- 2. 접수 시 안내사항 -->
        <article class="section-accordion__item">
          <h3 class="section-accordion__header">
            <button
              type="button"
              class="section-accordion__btn"
              aria-controls="panel-2"
              id="accordion-trigger-2"
            >
              <span class="section-accordion__num" aria-hidden="true"></span>
              <span class="section-accordion__title">접수 시 안내사항</span>
            </button>
          </h3>
          <div
            id="panel-2"
            class="section-accordion__panel"
            role="region"
            aria-labelledby="accordion-trigger-2"
          >
            <div class="section-accordion__content">
              조치 계획서 접수 과정에서 오류가 지속적으로 발생하는 경우, 아래
              자료를 첨부하여 vuln_notice@boho.or.kr로 메일을 보내주시기
              바랍니다.<br />
              1. 패치 계획서<br />
              2. 오류 화면 캡쳐<br />
              ※ 메일 제목에는 [패치계획서 접수] 문구와 취약점 제목, 전달받으신
              KVE 번호를 함께 기재해 주시기 바랍니다.<br />
              예시) [패치계획서 접수] 보안 취약점 정보포털 정보 유노출 취약점
              (KVE-2026-0001)
            </div>
          </div>
        </article>
      </section>

      <PatchRequestList
        v-if="isModal"
        :isModal="isModal"
        :submitType="replyInfo.submitType === 'P' ? 'N' : 'E'"
        @add="applySelection"
        @close="closeModal"
      />
      <ReportViewModalVue
        v-if="isVerifyModal"
        :isModal="isVerifyModal"
        :reportKve="reportKve"
        @close="closeVerifyModal"
      />
    </div>
  </div>
</template>
<script>
import { sha256HashFile } from "@/component/Crypto.js";
import dc from "@/component/DataChk.js";
import FileUpload from "@/component/FileUpload.vue";
import Tooltip from "@/component/Tooltip.vue";
import StacksEditor from "@/editor/StacksEditor.vue";
import {
  deepEqual,
  loadFromIndexedDB,
  saveToIndexedDB,
} from "@/views/tempSave/TempSave.js";
import { computed, inject, onMounted, reactive, ref, toRaw, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import PatchRequestList from "./modal/PatchRequestList.vue";
import ReportViewModalVue from "./modal/ReportViewModal.vue";
import pactchHandler from "./PatchHandler.js";

export default {
  components: {
    PatchRequestList,
    StacksEditor,
    Tooltip,
    FileUpload,
    ReportViewModalVue,
  },
  props: {
    modelValue: { type: Object, required: true },
    userInfo: { type: Object, required: true },
    edit: { type: Boolean, required: true },
    detailMod: { type: Boolean, required: true },
    patchRequestList: { type: Object, required: true },
    patchGuidesCodes: { type: Object, required: false },
    tmpDeliveryStatusCodes: { type: Object, required: true },
  },
  setup(props, { emit, expose }) {
    const lodash = inject("lodash");
    const axios = inject("axios");
    const store = useStore();
    const router = useRouter();
    const saver = inject("filesaver");
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const replyInfo = ref(lodash.cloneDeep(props.modelValue.replyInfo));
    const submitInfo = ref(lodash.cloneDeep(props.modelValue.submitInfo));
    const uploadFile = ref(props.modelValue.uploadFile);
    const actionGuideFiles = ref(props.modelValue.actionGuideFiles);
    const patchRequestList = ref([]);
    const windowWidth = ref(window.innerWidth);
    const isModal = ref(false);
    const replyCnEditorKey = ref(0); // editor 리렌더링 값
    const guideEditorKey = ref(0); // editor 리렌더링 값
    const hashFileInput = ref(null); // 해시 파일 입력 요소
    const allowExt = ref([
      "png",
      "jpg",
      "gif",
      "pdf",
      "xlsx",
      "xls",
      "zip",
      "tar",
      "7z",
    ]);
    const hashInputMethod = ref(null); // 'direct' 또는 'file'
    const hashFile = ref(null); // 해시 파일 정보
    const deliveryStatusCodes = ref(
      lodash.cloneDeep(props.tmpDeliveryStatusCodes)
    );
    const isVerifyModal = ref(false);
    const selectedPatches = ref([]);
    const reportKve = ref(null);
    const isDirty = ref(false);
    const lastSavedData = ref(null);
    const EXPIRE_TIME_MS = 60 * 60 * 1000;
    const dbName = "vulPatch_db";
    const storeName = "patchStore";
    const delayTime = 800;

    // methods 정의
    const handleFileAdd = (addedFiles, type) => {
      // FileUpload 컴포넌트에서 전달받은 파일 목록 처리
      const file = addedFiles.length > 0 ? addedFiles[0] : null;
      if (type === "default") {
        uploadFile.value = file;
      } else {
        actionGuideFiles.value = file;
      }
    };

    // Methods 정의
    const addVulnVersionRange = () => {
      replyInfo.value.hasNoVulnVer = false;
      if (!props.detailMod) {
        replyInfo.value.noVulnVerReason = null;
      }

      replyInfo.value.vulnVersionRange.push(
        pactchHandler.createDefaultVulnVersionRange()
      );
    };
    const removeVulnVersionRange = (index) => {
      if (replyInfo.value.vulnVersionRange.length > 1) {
        replyInfo.value.vulnVersionRange.splice(index, 1);
      }
    };
    const addPatchVersionMap = () => {
      replyInfo.value.patchVersionMap.push(
        pactchHandler.createDefaultPatchVersionMap()
      );
    };
    const removePatchVersionMap = (index) => {
      // 취약한 버전, 해결된버전, 해시 등록방법 행삭제
      if (replyInfo.value.patchVersionMap.length > 1) {
        replyInfo.value.patchVersionMap.splice(index, 1);
      }
    };

    const onHashFileClick = (index) => {
      // 파일 및 해시 처리 (File & Hash Handling)
      if (hashFileInput.value && hashFileInput.value[index]) {
        hashFileInput.value[index].click();
      }
    };
    const onHashFileChange = async (event, index) => {
      // 파일 추출 해시 표현
      const file = event.target.files[0];
      if (!file) return;
      hashFile.value = file;

      try {
        // hash.js 유틸리티 함수를 사용하여 해시 값을 계산
        const hash = await sha256HashFile(file);
        // 계산된 해시 값을 해당 버전 정보에 할당
        replyInfo.value.patchVersionMap[index].fileHash = hash;
      } catch (e) {
        console.error(e);
      }
    };

    const onDeliveryStatusChange = (status) => {
      // 납품현황 입력 제어
      if (!status.checked) {
        status.count = 0; // 체크 해제 시 수량 초기화
      }

      if (status.cd === "NOT" && status.checked) {
        // 제공안함 선택 시 다른 모든 항목 해제
        deliveryStatusCodes.value.forEach((item) => {
          if (item.cd !== "NOT") {
            item.checked = false;
            item.count = 0;
          }
        });
      }
    };
    const applyDeliveryStatusFromReply = () => {
      if (!Array.isArray(deliveryStatusCodes.value)) {
        return;
      }

      const items = Array.isArray(replyInfo.value.deliveryStatus)
        ? replyInfo.value.deliveryStatus
        : [];
      if (items.length === 0) {
        const hasChecked = deliveryStatusCodes.value.some(
          (status) => status.checked
        );
        if (hasChecked) {
          return;
        }
      }
      const map = new Map(items.map((item) => [item.deliveryCode, item]));

      deliveryStatusCodes.value.forEach((status) => {
        const matched = map.get(status.cd);
        status.checked = Boolean(matched);
        status.count = matched ? matched.deliveryCnt ?? 0 : 0;
      });
    };
    const syncDeliveryStatusToReply = () => {
      if (!Array.isArray(deliveryStatusCodes.value)) {
        replyInfo.value.deliveryStatus = [];
        return;
      }

      replyInfo.value.deliveryStatus = deliveryStatusCodes.value
        .filter((status) => status.checked)
        .map((status) => ({
          deliveryCode: status.cd,
          deliveryCnt: status.cd === "NOT" ? 0 : Number(status.count || 0),
        }));
    };
    const readVulnVersionRange = () => {
      const item = replyInfo.value.vulnVersionRange;

      if (replyInfo.value.hasNoVulnVer) {
        const reason = replyInfo.value.noVulnVerReason || "-";
        return "[버전 미관리 사유] " + reason;
      }

      if (!Array.isArray(item) || item.length === 0) return "-";

      return item
        .map((e) => {
          const minVersion = e?.minVersion ?? "-";
          const minVersionRange =
            e?.minVersionRange === "INCLD" ? "이상" : "초과";
          const maxVersion = e?.maxVersion ?? "-";
          const maxVersionRange =
            e?.maxVersionRange === "INCLD" ? "이하" : "미만";

          return `${minVersion}${minVersionRange} ~ ${maxVersion}${maxVersionRange}`;
        })
        .join("\n");
    };
    const readPatchVersionMap = () => {
      const item = replyInfo.value.patchVersionMap;

      if (!Array.isArray(item) || item.length === 0) return "-";

      return item
        .map((e) => {
          const vulnVersion = e?.vulnVersion ?? "-";
          const patchedVersion = e?.patchedVersion ?? "-";
          const fileHash = e?.fileHash ?? "-";
          return `취약한 버전 : ${vulnVersion}
          해결된 버전 : ${patchedVersion}
          파일 해시 : ${fileHash}
          ------------------------------------------------------------------------------------`;
        })
        .join("\n");
    };

    const readDeliveryStatus = () => {
      const item = replyInfo.value.deliveryStatus;
      if (!Array.isArray(item) || item.length === 0) return "-";

      return item
        .map((e) => {
          const deliveryCode = convertDeliveryNm(e?.deliveryCode);
          const deliveryCnt = e?.deliveryCnt ?? "-";

          return `${deliveryCode}(${deliveryCnt})개`;
        })
        .join(", ");
    };

    const readPatchGuide = () => {
      const item = replyInfo.value.patchGuides;
      if (!Array.isArray(item) || item.length === 0) return "-";

      return item
        .map((e) => {
          return convertGuideNm(e);
        })
        .join(", ");
    };

    const convertDeliveryNm = (deliveryCode) => {
      const matchingStatus = deliveryStatusCodes.value.find(
        (code) => code.cd === deliveryCode
      );
      return matchingStatus ? matchingStatus.cdNm : "-";
    };
    const convertGuideNm = (data) => {
      const matchingGuide = props.patchGuidesCodes.find(
        (guide) => guide.cd === data
      );
      return matchingGuide ? matchingGuide.cdNm : "-";
    };
    const openModal = () => {
      isModal.value = true;
    };
    const closeModal = () => {
      isModal.value = false;
    };
    const openVerifyModal = (kve) => {
      showLoading();
      axios
        .post("/patch/pr/mail/password/send", { kve })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            isVerifyModal.value = true;
            reportKve.value = kve;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const closeVerifyModal = () => {
      isVerifyModal.value = false;
      reportKve.value = null;
    };

    const handleNoVulnVer = () => {
      replyInfo.value.hasNoVulnVer = !replyInfo.value.hasNoVulnVer;
      replyInfo.value.vulnVersionRange = [
        pactchHandler.createDefaultVulnVersionRange(),
      ];
      replyInfo.value.patchVersionMap = [
        pactchHandler.createDefaultPatchVersionMap(),
      ];
    };

    const applySelection = (item) => {
      // 패치 접수 선택된 목록 적용
      if (item.length > 0) {
        submitInfo.value.submitRequestInfos = item.map(
          ({ kve, title, swCode }) => ({
            kve,
            title,
            swCode,
          })
        );

        selectedPatches.value = item.map((p) => p.kve).join(", ");
      }
      closeModal();
    };

    const updateWindowWidth = () => {
      windowWidth.value = window.innerWidth;
    };
    const hasFile = (attachment) => {
      // 파일 존재 여부 확인
      if (!dc.nullChk(attachment)) {
        return false;
      }

      if (!dc.nullChk(attachment.dir)) {
        return false;
      }

      if (!dc.nullChk(attachment.name)) {
        return false;
      }

      return true;
    };
    const onHtmlChanged = ({ id, html }) => {
      if (id === "replyCn") {
        replyInfo.value.replyCnHtml = html;
      } else if (id === "actionGuide") {
        replyInfo.value.actionGuideHtml = html;
      }
    };
    const downloadFile = (attachment) => {
      if (!hasFile(attachment)) {
        return;
      }

      showLoading();
      axios({
        method: "POST",
        url: "/patch/pr/file/attach/download",
        responseType: "blob",
        headers: { "Content-Type": "application/json" },
        data: attachment,
      })
        .then((response) => {
          if (response.data.size === 0) {
            alert("해당 경로에 파일이 존재하지 않습니다.");
            return;
          }
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          saver.saveAs(blob, attachment.name);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const loadPatchPlan = (kve) => {
      showLoading();
      replyCnEditorKey.value = 0;
      guideEditorKey.value = 0;
      axios
        .post("/patch/pr/submission/plan/get", { kve })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            Object.assign(replyInfo.value, res.data.resList[0].patchInfo);
            //에디터 데이터 초기화
            if (!dc.nullChk(replyInfo.value?.actionGuide)) {
              replyInfo.value.actionGuide = "";
            }
            if (!dc.nullChk(replyInfo.value?.replyCn)) {
              replyInfo.value.replyCn = "";
            }
            // list data 초기 셋팅
            if (!dc.nullChk(replyInfo.value?.vulnVersionRange)) {
              replyInfo.value.vulnVersionRange = [];
              addVulnVersionRange();
            }
            if (!dc.nullChk(replyInfo.value?.patchVersionMap)) {
              replyInfo.value.patchVersionMap = [];
              addPatchVersionMap();
            }

            applyDeliveryStatusFromReply();

            replyCnEditorKey.value++;
            guideEditorKey.value++;

            // 불러오기해도 조치 구분은 그대로
            replyInfo.value.submitType = "R";
          } else {
            alert("조회된 조치 계획서 접수 내용이 없습니다.");
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const initSelectedPatches = () => {
      selectedPatches.value = [];
      submitInfo.value.submitRequestInfos = [];
    };

    const isDeliveryStatusDisabled = (status) => {
      const notItem = deliveryStatusCodes.value.find(
        (item) => item.cd === "NOT"
      );
      if (notItem && notItem.checked) {
        return status.cd !== "NOT";
      }
      return false;
    };

    // IndexedDB에서 데이터 불러오기
    const handleLoadFromIndexedDB = async (options = {}) => {
      await loadFromIndexedDB({
        dbName,
        storeName,
        saveId: replyInfo.value.id || "tempData_" + Date.now(),
        requireIdMatch: options.requireIdMatch,
        confirmMsgFn: (targetData) => {
          return confirm(
            `저장된 데이터를 불러오시겠습니까?\n\n저장시간: ${new Date(
              targetData.savedAt
            ).toLocaleString()}`
          );
        },
        onRestore: (restoredData) => {
          if (restoredData.replyInfo) {
            Object.assign(replyInfo.value, restoredData.replyInfo);
          } else {
            Object.assign(replyInfo.value, restoredData);
          }
          if (restoredData.submitInfo) {
            Object.assign(submitInfo.value, restoredData.submitInfo);
          }
          if (Array.isArray(restoredData.deliveryStatusCodes)) {
            deliveryStatusCodes.value = restoredData.deliveryStatusCodes;
            syncDeliveryStatusToReply();
          } else {
            applyDeliveryStatusFromReply();
          }
          selectedPatches.value = Array.isArray(
            submitInfo.value.submitRequestInfos
          )
            ? submitInfo.value.submitRequestInfos.map((p) => p.kve).join(", ")
            : "";
          replyCnEditorKey.value++;
          guideEditorKey.value++;
          lastSavedData.value = {
            replyInfo: lodash.cloneDeep(replyInfo.value),
            submitInfo: lodash.cloneDeep(submitInfo.value),
            deliveryStatusCodes: lodash.cloneDeep(deliveryStatusCodes.value),
          };
          isDirty.value = false;
        },
      });
    };

    // IndexedDB 저장 함수
    const handleSaveToIndexedDB = async (data) => {
      try {
        const saveId = replyInfo.value.id || "tempData_" + Date.now();

        await saveToIndexedDB({
          dbName,
          storeName,
          data: toRaw(data),
          saveId,
          EXPIRE_TIME_MS,
        });
      } catch (e) {
        console.error(e);
      }
    };

    // Debounce 유틸리티 함수
    const debounce = (func, delay) => {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
      };
    };

    const debouncedSave = debounce(() => {
      if (!isDirty.value) {
        return;
      }

      const currentData = {
        replyInfo: replyInfo.value,
        submitInfo: submitInfo.value,
        deliveryStatusCodes: deliveryStatusCodes.value,
      };

      // 이전 저장값과 diff 비교
      if (lastSavedData.value && deepEqual(currentData, lastSavedData.value)) {
        return;
      }

      handleSaveToIndexedDB(currentData);

      // 저장 완료 후 상태 업데이트
      lastSavedData.value = lodash.cloneDeep(currentData);

      isDirty.value = false;
    }, delayTime);

    // watch 정의
    watch(
      () => props.tmpDeliveryStatusCodes,
      (newVal) => {
        if (!lodash.isEqual(deliveryStatusCodes.value, newVal)) {
          deliveryStatusCodes.value.splice(
            0,
            deliveryStatusCodes.value.length,
            ...newVal
          );
          applyDeliveryStatusFromReply();
          isDirty.value = true;
        }
      },
      { deep: true }
    );
    watch(
      deliveryStatusCodes,
      (newVal) => {
        emit("update:deliveryStatusCodes", newVal);
      },
      { deep: true }
    );
    watch(
      replyInfo,
      (newVal) => {
        isDirty.value = true;
        debouncedSave();

        emit("update:modelValue", {
          ...props.modelValue,
          replyInfo: newVal,
        });
      },
      { deep: true }
    );
    watch(
      submitInfo,
      (newVal) => {
        isDirty.value = true;
        debouncedSave();

        emit("update:modelValue", {
          ...props.modelValue,
          submitInfo: newVal,
        });
      },
      { deep: true }
    );

    watch(
      uploadFile,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          uploadFile: newVal,
        });
      },
      { deep: true }
    );
    watch(
      actionGuideFiles,
      (newVal) => {
        emit("update:modelValue", {
          ...props.modelValue,
          actionGuideFiles: newVal,
        });
      },
      { deep: true }
    );
    watch(
      () => props.edit,
      (newVal, oldVal) => {
        // edit이 false에서 true로 변경되었을 때
        if (!oldVal && newVal) {
          handleLoadFromIndexedDB({ requireIdMatch: true });
        }
      }
    );

    // computed 정의
    const bigoCount = computed(() => (replyInfo.value.bigo || "").length);
    const reasonCount = computed(
      () => (replyInfo.value.noVulnVerReason || "").length
    );

    // life cycle 정의
    onMounted(() => {
      lastSavedData.value = {
        replyInfo: lodash.cloneDeep(replyInfo.value),
        submitInfo: lodash.cloneDeep(submitInfo.value),
      };
      isDirty.value = false;

      if (props.edit) {
        handleLoadFromIndexedDB();
      }
      window.addEventListener("resize", updateWindowWidth);
    });

    // 부모에게 공개
    expose({
      handleLoadFromIndexedDB,
    });

    //  html에서 사용될 데이터 정의
    return {
      readPatchGuide,
      readDeliveryStatus,
      readPatchVersionMap,
      readVulnVersionRange,
      initSelectedPatches,
      isDeliveryStatusDisabled,
      uploadFile,
      actionGuideFiles,
      submitInfo,
      selectedPatches,
      windowWidth,
      patchRequestList,
      isModal,
      closeModal,
      openModal,
      applySelection,
      replyInfo,
      onDeliveryStatusChange,
      hashInputMethod,
      addVulnVersionRange,
      removeVulnVersionRange,
      addPatchVersionMap,
      removePatchVersionMap,
      onHashFileClick,
      onHashFileChange,
      hashFileInput,
      hashFile,
      bigoCount,
      replyCnEditorKey,
      guideEditorKey,
      allowExt,
      handleFileAdd,
      downloadFile,
      onHtmlChanged,
      deliveryStatusCodes,
      loadPatchPlan,
      reasonCount,
      openVerifyModal,
      closeVerifyModal,
      isVerifyModal,
      reportKve,
      handleNoVulnVer,
    };
  },
};
</script>
